import Meta from "../Meta";
import "./home.css";
import Brand from "./hooks/Brand";
import Contactform from "./hooks/Contactform";
import Growth from "./hooks/Growth";
import Growthhead from "./hooks/Growthhed";
import Hero from "./hooks/Hero";
import Whatwedo from "./hooks/Whatwedo";

export default function Home() {
    return(  
        <>
      <Meta title="Home" />
      <Hero />
      <Growthhead colclass={`col-md-6`}  title={<> <span>ACTIVATING GROWTH -</span>  ONE INSIGHT AT A TIME!</>} />
      <Growth />
      <Brand />
      <Whatwedo />
      <Contactform />
      </>
    )
}
